"use client";

// src/components/default/check.tsx
import * as React from "react";
import { useUID } from "@stepstone-genesis/uid-library";
import { systemForwardRef } from "@stepstone-genesis/system";
import {
  IconContainer
} from "@stepstone-genesis/icon-containers";
var CheckIcon = systemForwardRef(function IconWrapper({ title, id, display, size, color, ...rest }, ref) {
  const identifier = useUID();
  const titleId = title ? `CheckIcon-${id != null ? id : identifier}` : void 0;
  const role = title ? "img" : "presentation";
  const componentName = `CheckIcon`;
  return /* @__PURE__ */ React.createElement(
    IconContainer,
    {
      ...rest,
      display,
      size,
      color,
      ref
    },
    /* @__PURE__ */ React.createElement(
      "svg",
      {
        "data-genesis-element": componentName,
        role,
        width: "100%",
        height: "100%",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": titleId
      },
      title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
      /* @__PURE__ */ React.createElement(
        "path",
        {
          fill: "currentColor",
          d: "M8.22923 12.2421L13.8655 6.62668C13.9755 6.51664 14.0984 6.46375 14.234 6.46801C14.3697 6.47229 14.4953 6.53212 14.6106 6.64751C14.726 6.76289 14.7837 6.88708 14.7837 7.0201C14.7837 7.1531 14.726 7.27729 14.6106 7.39268L8.71479 13.2885C8.57804 13.4252 8.41966 13.4936 8.23965 13.4936C8.05963 13.4936 7.90125 13.4252 7.7645 13.2885L5.3895 10.9135C5.27946 10.8035 5.22177 10.6806 5.21642 10.5449C5.21108 10.4092 5.26611 10.2837 5.38148 10.1683C5.49687 10.053 5.62106 9.99526 5.75406 9.99526C5.88708 9.99526 6.01127 10.053 6.12665 10.1683L8.22923 12.2421Z"
        }
      )
    )
  );
});
export {
  CheckIcon
};
